import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/sms';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async getMobiles(params: any) {
    return api.getMobiles(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async tpllist(params: any) {
    return api.tpllist(params);
  }

  @Action
  async addtpl(params: any) {
    return api.addtpl(params);
  }

  @Action
  async edittpl(params: any) {
    return api.edittpl(params);
  }

  @Action
  async tpldetail(params: any) {
    return api.tpldetail(params);
  }

  @Action
  async deletetpl(params: any) {
    return api.deletetpl(params);
  }

  @Action
  async tplselect(params: any) {
    return api.tplselect(params);
  }

  @Action
  async app(params: any) {
    return api.app(params);
  }

  @Action
  async appadd(params: any) {
    return api.appadd(params);
  }

  @Action
  async admin(params: any) {
    return api.admin(params)
  }

  @Action
  async sendPending(params: any) {
    return api.sendPending(params);
  }
}
